import React from "react";

import { EvidenceSignals } from "pages/admin/verifications/components/automations/EvidenceSignals";
import { EvidenceSignal } from "pages/admin/verifications/components/automations/types";

type EvidenceRowProps = {
  signals: EvidenceSignal[];
  title: string;
  onClick: () => void;
};

export const EvidenceRow = ({ signals, title, onClick }: EvidenceRowProps) => (
  <button type="button" className="evidence-row" title={title} onClick={onClick}>
    <EvidenceSignals signals={signals} />
  </button>
);
